// JS Script
import VanillaCalendar from '@uvarov.frontend/vanilla-calendar';

// Basic styles
import '@uvarov.frontend/vanilla-calendar/build/vanilla-calendar.min.css';

// Additional styles
import React, { useEffect, useRef } from 'react';
import {
	dayJS,
	dayToDate,
	formatDate,
	getMonth,
	getYear,
} from '../../../../../utils/date';

function DatePicker({ selectedDate, setSelectedDate, desiredDays }) {
	const vanillaCalender = useRef(null);
	const calendar = useRef(null);

	useEffect(() => {
		if (!vanillaCalender.current) return;
		if (calendar.current) return;

		const options = {
			settings: {
				visibility: {
					theme: 'light',
				},
				lang: 'fr',
				range: {
					min: dayJS().format('YYYY-MM-DD'),
					disablePast: true,
				},
			},
			CSSClasses: {
				header: 'calendar-header',
				dayBtnToday: 'calendar-day-today',
				dayBtn: 'calendar-day__btn',
				arrowPrev: 'calendar-arrow_prev',
				arrowNext: 'calendar-arrow_next',
				headerContent: 'calendar-header__content',
				weekDay: 'calendar-week__day',
				dayBtnSelected: 'calendar-day-selected',
				month: 'calendar-month',
				year: 'calendar-year',
				dayBtnDisabled: 'calendar-day-disabled',
			},
			actions: {
				clickDay(e, dates) {
					if (dates.length === 0) setSelectedDate(new Date().toISOString());
					else if (dayJS(dates[0]).isBefore(dayJS(), 'day'))
						setSelectedDate(dayJS().toISOString());
					else setSelectedDate(new Date(dates[0]).toISOString());
				},
				clickArrow(e, year, month) {
					refreshDesiredDays();
				},
				clickMonth(e, month) {
					setTimeout(() => refreshDesiredDays(), 15);
				},
				clickYear(e, year) {
					setTimeout(() => refreshDesiredDays(), 15);
				},
			},
		};
		const calendarElm = new VanillaCalendar(vanillaCalender.current, options);
		calendar.current = calendarElm;
		calendar.current.init();
		/* eslint-disable */
	}, [vanillaCalender, setSelectedDate]);

	useEffect(() => {
		if (!calendar.current) return;

		calendar.current.settings.selected.dates = [
			formatDate(selectedDate, 'YYYY-MM-DD'),
		];
		calendar.current.settings.selected.month = getMonth(selectedDate);
		calendar.current.settings.selected.year = getYear(selectedDate);
		calendar.current.update();
	}, [calendar, selectedDate]);

	useEffect(() => {
		/* eslint-disable */
		refreshDesiredDays();
	}, [selectedDate]);

	function refreshDesiredDays() {
		const dayIndexes = desiredDays?.map((day) => dayToDate[day]);
		dayIndexes?.forEach((dayIndex) => {
			const indexResult = dayIndex - 6;
			const dayElms = document.querySelectorAll(
				`div.vanilla-calendar-days > div:nth-child(7n${
					indexResult > 0 ? '+' + indexResult : indexResult
				})`
			);

			dayElms?.forEach((elm) => elm?.classList?.add('calendar-favorite-day'));
		});
	}

	return (
		<>
			<div ref={vanillaCalender}></div>
		</>
	);
}

export default DatePicker;
